import { BranchUpdatePage } from '@/features/branch/pages/BranchUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/branch/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["branch.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BranchUpdatePage,
})
